<template>
  <footer class="bg-dark text-white py-1 mt-2">
    <div class="container-fluid text-center">
     <br><br><br>
     <p class="small">
          Company No. 16467253 <br>
          Registered in England & Wales<br>
          Registered Office: London, WC2H 9JQ<br>
          &copy;StepEdge Academy Ltd 2025 - All rights reserved.
    </p> 
    <router-link to="/policies" class="nav-link dropdown-toggle text-white text-decoration-none">
      Safeguarding, Privacy & Policies
    </router-link>

  </div>
</footer>
</template>
